import React from "react"

function Label({ children, className=" font-regular text-gray-900 ", isRequired, ...props }) {
    return (
        <label
            className={`${className}`}
            {...props}>
            {children} {isRequired&& <i className="text-red-500">*</i>}
        </label>
    )
}
export default React.memo(Label);
